import { store } from "../store";
import {
  setTrendingMovies,
  setTrendingShows,
} from "../store/slices/mediaSlice";
import { tmdbApi } from "./tmdb";

class SyncService {
  private syncInterval: NodeJS.Timeout | null = null;

  initialize() {
    console.log('Service de synchronisation démarré');
    this.startSync();
  }

  private startSync() {
    // Synchroniser immédiatement au démarrage
    this.syncData();

    // Configurer la synchronisation périodique
    this.syncInterval = setInterval(() => {
      this.syncData();
    }, 5 * 60 * 1000); // Toutes les 5 minutes
  }

  private async syncData() {
    try {
      console.log("Starting TMDB data sync...");

      // Récupérer les données de l'API TMDB
      const [movies, shows] = await Promise.all([
        tmdbApi.getTrending("movie"),
        tmdbApi.getTrending("tv")
      ]);

      // Mettre à jour le store
      store.dispatch(setTrendingMovies(movies.results));
      store.dispatch(setTrendingShows(shows.results));

      console.log("TMDB data sync completed successfully");
    } catch (error) {
      console.error("Error syncing TMDB data:", error);
    }
  }

  stop() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
      this.syncInterval = null;
    }
  }
}

export const syncService = new SyncService();
